import Canvas from "./Canvas.js";
import TOwObject from "./TOwObject.js";

export default class TestCanvas extends Canvas {
    transitions = [];

    constructor(props) {
        super(props);

        this.width = this.props.width;
        this.height = this.props.height;

        this.keyframesWP = this.props.keyframes || [];
    }

    calcMax() {
        this.maxTime = 0;
        this.keyframesWP.forEach(ko =>
            ko.keyframes.forEach(kf =>
                kf.time > this.maxTime
                    ? (this.maxTime = kf.time)
                    : (this.maxTime = this.maxTime)
            )
        );
    }

    onInit() {
        const x = 100;
        const startY = 10;
        const incrY = 38;

        // console.log(this.keyframesWP.map(obj => obj.keyframes));
        this.calcMax();

        // this.maxTime = this.keyframesWP.map(obj => obj.keyframes).reduce((max, p) => p.time > max ? p.time : max, 0);
        //
        // console.log(this.maxTime);

        for (let i = this.keyframesWP.length - 1; i >= 0; i--) {
            const k = this.keyframesWP[i];
            const prop = k.property;
            const kfs = k.keyframes;

            const color = k.color || "white";

            const duration = kfs[kfs.length - 1].time;
            const w = -((this.width - 120) / this.maxTime) * duration;
            // const w = 80;

            const nobj = new TOwObject(
                this,
                prop,
                x,
                startY + i * incrY,
                w,
                31,
                kfs,
                { primaryColor: color }
            );

            nobj.on("mousedown", e => {
                if (this.props.test) {
                    this.props.test(prop);
                }
            });

            this.transitions.push(nobj);
        }

        for (let t of this.transitions) this.objects.push(t);

        this.background("#252A33");
    }

    notify(property, newKF) {
        this.calcMax();
        for (let transition of this.transitions) {
            if (transition.property.toLowerCase() === property.toLowerCase()) {
                const duration = newKF[newKF.length - 1].time;
                const w = -((this.width - 120) / this.maxTime) * duration;
                transition.width = w;
                transition.keyframesDidUpdate(newKF);
            }
        }
        this.notifyUpdate();
    }

    onDraw() {
        this.clear();

        const context = this.getContext();

        const x = 10;
        const startY = 30;
        const incrY = 38;

        context.save();

        context.font = "20px Microsoft Yi Baiti";
        context.textAlign = "left";

        for (let i = 0; i < this.keyframesWP.length; i++) {
            const k = this.keyframesWP[i];
            const prop = k.property;

            const color = k.color;
            context.fillStyle = color.value;

            context.fillText(prop, x, startY + i * incrY);
        }

        context.restore();

        super.onDraw();
    }
}



// WEBPACK FOOTER //
// ./src/components/canvas/TestCanvas.js